import { IGameState } from '../State/Game/IGameState';
import DataManager from './DataManager';
import Game from '../Game';
import { WorldDataHelper } from '../Utility/WorldDataHelper';
import { LevelType, IPlayerLevelData } from '../State/Player/Progress/PlayerLevels';
import { getHighestLevelCompleted } from '../State/Player/PlayerLevelHelper';
import { Immutable } from '../Utility/Types';
import { ProgressStateHelper } from 'State/Player/Progress/ProgressStateHelper';
import { ILimit } from 'Utility/MathHelper';

export default class Player {
    public data: DataManager;

    constructor() {
        this.data = new DataManager();
    }

    public handleStateChanged(state: IGameState): void {
        this.data.handleStateChanged(state);
    }

    public getAvatarTexture() {
        if (Game.resource.existsAndLoaded('player_avatar')) {
            return 'player_avatar';
        }

        return 'no_avatar';
    }

    public getCardBackTexture(): string {
        return 'backcard_1';
    }

    /**
     * Player's current level number (the player's most recently unlocked level).
     */
    public getHighestLevelCompleted(
        state: Immutable<IGameState> = Game.store.getState(),
        levelType?: LevelType
    ): number {
        return getHighestLevelCompleted(state.playerState, levelType);
    }
    /**
     * Returns the total number of stars acquired
     */
    public totalStars(levelType: LevelType = LevelType.Core): number {
        const completedLevels: IPlayerLevelData[] = Game.store
            .getState()
            .playerState.levels[levelType].filter((levelData: IPlayerLevelData) => levelData.stars !== undefined);

        return completedLevels.reduce((a, b) => a + b.stars, 0);
    }
    /**
     * Returns the number of stars acquired in the given world.
     * @param worldNumber
     */
    public getWorldStars(worldNumber: number, levelType: LevelType = LevelType.Core): number {
        const levels: IPlayerLevelData[] = Game.store.getState().playerState.levels[levelType];

        const levelLimits: ILimit = WorldDataHelper.getWorldLevelLimits(worldNumber);
        const worldLevels = levels.slice(levelLimits.min, levelLimits.min);
        return worldLevels.reduce((a, b) => a + b.stars, 0);
    }

    /**
     * If player level is greater than the highest level in the
     * current world return the last level in this world.
     *
     * If the player level is less than the lowest level in the
     * current world return the first level in this world.
     *
     * @param worldNumber
     */
    public getNextLevelInWorld(worldNumber: number, state?: IGameState): number {
        const levelLimits: ILimit = WorldDataHelper.getWorldLevelLimits(worldNumber);

        const currentLevel = this.getHighestLevelCompleted(state) + 1;

        if (currentLevel > levelLimits.max) {
            return levelLimits.max;
        } else if (currentLevel < levelLimits.min) {
            return levelLimits.min;
        } else {
            return currentLevel;
        }
    }
    public canGateOpen(worldNumber: number): boolean {
        const currentLevel: number = this.getNextLevelInWorld(worldNumber);
        const stars: number = ProgressStateHelper.getLevelStars(Game.store.getState(), currentLevel);

        return stars > 0;
    }
    public getUnlockedFields(): string[] {
        return Game.store.getState().playerState.fields;
    }
}
